import devConfig from './config.dev';
import testConfig from './config.test';
import prodConfig from './config.prod';
import preConfig from './config.pre';
import globalConfig from './config.global';

const ENV = {
  DEV: 'DEV',
  TEST: 'TEST',
  PROD: 'PROD',
  PRE: 'PRE',
  GLOBAL: 'GLOBAL'
};
const envMapConfig = {
  [ENV.DEV]: devConfig,
  [ENV.TEST]: testConfig,
  [ENV.PROD]: prodConfig,
  [ENV.PRE]: preConfig,
  [ENV.GLOBAL]: globalConfig
};
const REACT_APP_ENV = process.env.REACT_APP_ENV || ENV.DEV;
const getConfig = () => {
  return envMapConfig[REACT_APP_ENV];
};

export default getConfig();
